import './index.scss';

import React, { useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// import axios from '../../admin-axios';
import useActions from '../../hooks/useActions';
import LongPaginationHandler from '../LongPaginationHandler';

const ApprovedTransactionsTable = ({ match }) => {
  const tableDate = useRef('2022-11-17');
  const searchRef = useRef();
  const dateRef = useRef();
  const {
    approvedTransactions,
    loading,
    error,
    total,
    page,
    perPage,
    tranxView,
    searchResult,
    searchResultLoading,
    searchResultError,
    filterResult,
    filterResultLoading,
    filterResultError,
    filterResultPage,
    filterResultTotal,
    filterResultPerPage
  } = useSelector((state) => state.approved);
  const {
    getApprovedTransactions,
    setBackLink,
    setApprovedView,
    searchApprovedTransactions,
    filterApprovedTransactions
  } = useActions();

  const {
    user: { stationId }
  } = useSelector((state) => state.auth);

  const paginate = (pageNumber) => {
    getApprovedTransactions(stationId, pageNumber);
  };

  const paginateFilter = (pageNumber) => {
    getApprovedTransactions(dateRef.current.value, stationId, pageNumber);
  };

  const searchHandler = (event) => {
    if (event.code === 'Enter') {
      setApprovedView('searching');
      searchApprovedTransactions(searchRef.current.value);
      searchRef.current.value = '';
    }
  };

  const filterHandler = () => {
    setApprovedView('filtering');
    filterApprovedTransactions(dateRef.current.value, stationId, 1);
  };

  useEffect(() => {
    if (!approvedTransactions) {
      getApprovedTransactions(stationId, page);
    }
  }, [page, stationId, approvedTransactions, getApprovedTransactions]);

  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="approved_transactions">
      <div className="row mb-5">
        <div className="col-sm-6 col-md-8">
          <div className="approved_transactions_table_search">
            <input
              type="text"
              className="form-control p-2 approved_transactions_table_search_input"
              placeholder="Search by Transaction ID"
              aria-label="search"
              aria-describedby="button-addon2"
              ref={searchRef}
              onKeyDown={searchHandler}
            />
          </div>
        </div>
        <div className="col-sm-6 col-md-4">
          <div className="approved_transactions_filter row gx-2">
            <div className="col-7">
              <input
                type="date"
                name="filter_date"
                placeholder="Choose Filter Date"
                ref={dateRef}
                className="form-control approved_transactions_filter_input"
              />
            </div>
            <div className="col-5">
              <button
                disabled={filterResultLoading}
                onClick={filterHandler}
                className="btn"
                type="button">
                Apply Filter
              </button>
            </div>
          </div>
        </div>
      </div>
      {(tranxView === 'searching' || tranxView === 'filtering') && (
        <div className="">
          <button
            onClick={() => setApprovedView('normal')}
            type="button"
            className="mb-3 btn approved_transactions_general_button">
            Back to All Transactions
          </button>
        </div>
      )}
      <div className="approved_transactions_table">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">Transaction ID</th>
              <th scope="col">Customer Type</th>
              <th scope="col">Customer Name</th>
              <th scope="col">Phone No.</th>
              <th scope="col">Gas Quantity Purchased</th>
              <th scope="col">Price/Kg</th>
              <th scope="col">Amount</th>
              <th scope="col">Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          {tranxView === 'normal' && (
            <tbody>
              {error && (
                <tr>
                  <td colSpan={9}>
                    <div className="d-flex justify-content-center w-100">
                      <p className="text-danger">{error}</p>
                    </div>
                  </td>
                </tr>
              )}
              {/* eslint-disable-next-line no-nested-ternary */}
              {loading ? (
                <tr className="py-3">
                  <td colSpan={9}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              ) : approvedTransactions && approvedTransactions.length > 0 ? (
                approvedTransactions.map((tx) => {
                  const date = new Date(tx.created_at).toDateString();
                  if (date !== tableDate.current) {
                    tableDate.current = date;
                    return (
                      <React.Fragment key={tx.transaction_id}>
                        <tr className="approved_transactions_table_date_text text-end">
                          <td className="p-0" colSpan="9">
                            {tableDate.current}
                          </td>
                        </tr>
                        <tr>
                          <td>{tx.transaction_id}</td>
                          <td>{tx.customer_type}</td>
                          <td>
                            {tx.firstname} {tx.lastname}
                          </td>
                          <td>{tx.phone}</td>
                          <td>{tx.gas_quantity} Kg</td>
                          <td>N {tx.gas_price}</td>
                          <td>N {tx.amount}</td>
                          <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>
                            {tx.status}
                          </td>
                          <td>
                            <Link
                              to={`${match.url}/${tx.transaction_id}`}
                              onClick={() => setBackLink('/approved')}
                              className="btn approved_transactions_table_button">
                              View
                            </Link>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  }
                  return (
                    <tr key={tx.transaction_id}>
                      <td>{tx.transaction_id}</td>
                      <td>{tx.customer_type}</td>
                      <td>
                        {tx.firstname} {tx.lastname}
                      </td>
                      <td>{tx.phone}</td>
                      <td>{tx.gas_quantity} Kg</td>
                      <td>N {tx.gas_price}</td>
                      <td>N {tx.amount}</td>
                      <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>
                        {tx.status}
                      </td>
                      <td>
                        <Link
                          to={`${match.url}/${tx.transaction_id}`}
                          onClick={() => setBackLink('/approved')}
                          className="btn approved_transactions_table_button">
                          View
                        </Link>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={7} className="w-100 text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          )}
          {tranxView === 'searching' && (
            <tbody>
              {searchResultError && (
                <tr>
                  <td colSpan={9}>
                    <div className="d-flex justify-content-center w-100">
                      <p className="text-danger">{searchResultError}</p>
                    </div>
                  </td>
                </tr>
              )}
              {searchResultLoading && (
                <tr className="py-3">
                  <td colSpan={9}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              )}
              {!searchResultLoading &&
                searchResult &&
                searchResult.length > 0 &&
                searchResult.map((tx) => (
                  <tr key={tx.transaction_id}>
                    <td>{tx.transaction_id}</td>
                    <td>{tx.customer_type}</td>
                    <td>
                      {tx.firstname} {tx.lastname}
                    </td>
                    <td>{tx.phone}</td>
                    <td>{tx.gas_quantity} Kg</td>
                    <td>N {tx.gas_price}</td>
                    <td>N {tx.amount}</td>
                    <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>
                      {tx.status}
                    </td>
                    <td>
                      <Link
                        to={`${match.url}/${tx.transaction_id}`}
                        onClick={() => setBackLink('/approved')}
                        className="btn approved_transactions_table_button">
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              {!searchResultLoading && searchResult && searchResult.length === 0 && (
                <tr>
                  <td colSpan={9} className="w-100 text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          )}
          {tranxView === 'filtering' && (
            <tbody>
              {filterResultError && (
                <tr>
                  <td colSpan={9}>
                    <div className="d-flex justify-content-center w-100">
                      <p className="text-danger">{filterResultError}</p>
                    </div>
                  </td>
                </tr>
              )}
              {filterResultLoading && (
                <tr className="py-3">
                  <td colSpan={9}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              )}
              {filterResult &&
                filterResult.length > 0 &&
                filterResult.map((tx) => (
                  <tr key={tx.transaction_id}>
                    <td>{tx.transaction_id}</td>
                    <td>{tx.customer_type}</td>
                    <td>
                      {tx.firstname} {tx.lastname}
                    </td>
                    <td>{tx.phone}</td>
                    <td>{tx.gas_quantity} Kg</td>
                    <td>N {tx.gas_price}</td>
                    <td>N {tx.amount}</td>
                    <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>
                      {tx.status}
                    </td>
                    <td>
                      <Link
                        to={`${match.url}/${tx.transaction_id}`}
                        onClick={() => setBackLink('/approved')}
                        className="btn approved_transactions_table_button">
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              {filterResult && filterResult.length === 0 && (
                <tr>
                  <td colSpan={9} className="w-100 text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      </div>
      {tranxView === 'normal' && (
        <LongPaginationHandler
          elementsPerPage={perPage}
          totalElements={total}
          activePage={page}
          paginate={paginate}
        />
      )}
      {tranxView === 'filtering' && (
        <LongPaginationHandler
          elementsPerPage={filterResultPerPage}
          totalElements={filterResultTotal}
          activePage={filterResultPage}
          paginate={paginateFilter}
        />
      )}
    </div>
  );
};

export default ApprovedTransactionsTable;
